const sidebar = false;

const entity = {
  title: "Related Links",
  actions: {
    sort: {
      endPoint: "related_links/by",
      query: {
        $order: {},
      }
    },
    get: {
      endPoint: "related_links/by",
      query: {}
    },
    create: {
      endPoint: "related_links"
    },
    filter: {
      endPoint: "related_links/by",
      query: {
        $group: "id",
        $where: {}
      }
    }
  }
};

const keys = [{
  dataTableID: "id",
  tooltip: "ID used to generate this report",
  label: "Id",
  columnType: "string",
  table: {
    displayOrder: 1
  },
  filter: {
    displayOrder: 1,
    columnType: "select",
    matchType: "", // Values can be gte, lte, gt, lt, By default it is eq
    options: {
      select: [{
        field: "id"
      }],
      title: ["id"],
      value: "id",
      endPoint: "related_links/by",
      separator: " ",
      initializer: ""
    }
  }
},
{
  dataTableID: "title",
  tooltip: "Title of the related link",
  label: "Title",
  columnType: "string",
  create: {
    displayOrder: 1
  },
  table: {
    displayOrder: 2
  },
  filter: {
    displayOrder: 2
  }
},
{
  dataTableID: "url",
  tooltip: "URL of the related link",
  label: "URL",
  columnType: "string",
  create: {
    displayOrder: 2
  },
  table: {
    displayOrder: 3
  }
}
];

const tabs = [{
  view: "detailView",
  entity: "related_links",
  endPoint: "related_links/by",
  title: "Details",
  queryFilter: {
    id: ":id"
  }
}];

export {
  sidebar,
  entity,
  keys,
  tabs
};